import {
  SET_CLINICS_TIMES_WITH_SPECIALITY,
  SET_ACTIVE_CLINIC,
  SET_PATIENT_DETAILS,
  SET_CHECK_IN_INFO,
  LOGIN,
  SET_PROGRAMMED_GUARD_ID,
  SHOW_LOADER,
  HIDE_LOADER,
  SHOW_ERROR_MESSAGE,
  HIDE_ERROR_MESSAGE,
  CLEAR_PROGRAMMED_GUARD_STATE,
  SET_PROGRAMMED_GUARD_SCHEDULE,
  CLEAR_SMART_GUARD_STATE,
  LOGOUT,
  SET_GOL_ENABLED_SPECS,
  SET_PATIENT_CREATED
} from './actions'

/*
 * Auth
 */
export const authReducer = function(state = {}, action) {
  switch (action.type) {
    case LOGIN:
      return action.payload
    case LOGOUT:
      return {}
    default:
      return state
  }
}

/*
 * Loader
 */
export const loaderReducer = function(state = false, action) {
  switch (action.type) {
    case SHOW_LOADER:
      return true
    case HIDE_LOADER:
      return false
    default:
      return state
  }
}

/*
 * Error Message
 */
const errorMessageDefault = {
  message: ''
}
export const errorMessageReducer = function(state = errorMessageDefault, action) {
  switch (action.type) {
    case SHOW_ERROR_MESSAGE:
      return { message: action.payload }
    case HIDE_ERROR_MESSAGE:
      return errorMessageDefault
    default:
      return state
  }
}

/*
 * Smart Guard
 */
export const smartGuardDefaults = {
  speciality: null,
  clinicsTimes: [],
  checkIn: null,
  golEnabledSpecs: []
}
export const smartGuardReducer = function(state = smartGuardDefaults, action) {
  switch (action.type) {
    case SET_CLINICS_TIMES_WITH_SPECIALITY:
      return {
        ...state,
        ...action.payload
      }
    case SET_CHECK_IN_INFO:
      return {
        ...state,
        checkIn: action.payload
      }
    case SET_GOL_ENABLED_SPECS:
      return {
        ...state,
        golEnabledSpecs: action.payload
      }
    case CLEAR_SMART_GUARD_STATE:
      return {
        ...smartGuardDefaults
      }
    default:
      return state
  }
}

/*
 * Programmed Guard
 */
export const programmedGuardDefaults = {
  activeClinic: null,
  patientDetails: null,
  patientCreated: false,
  appointmentDetails: null,
  schedule: null,
  programmedId: null
}
export const programmedGuardReducer = function(state = programmedGuardDefaults, action) {
  switch (action.type) {
    case SET_ACTIVE_CLINIC:
      return {
        ...state,
        activeClinic: action.payload
      }
    case SET_PATIENT_DETAILS:
      return {
        ...state,
        patientDetails: action.payload
      }
    case SET_PATIENT_CREATED:
      return {
        ...state,
        patientCreated: action.payload
      }
    case SET_PROGRAMMED_GUARD_ID:
      return {
        ...state,
        programmedId: action.payload
      }
    case SET_PROGRAMMED_GUARD_SCHEDULE:
      return {
        ...state,
        schedule: action.payload
      }
    case CLEAR_PROGRAMMED_GUARD_STATE:
      return {
        ...programmedGuardDefaults
      }
    default:
      return state
  }
}
